import { utils } from '@hh/global.js'
const { addToCart, reRenderShopifySections, updateCart } = utils

class GiftWithPurchase extends HTMLElement {
  constructor() {
    super()

    this.handleClose = this.handleClose.bind(this)
    this.handleAddClick = this.handleAddClick.bind(this)
  }

  connectedCallback() {
    this.gwpLineKey = this.getAttribute('data-gwp-line-key')
    this.isGwpEligible = this.getAttribute('data-gwp-eligible') === 'true'

    this.drawer = this.querySelector('hh-drawer')
    this.closeButtons = this.querySelectorAll('[data-gwp-close]')
    this.addButtons = this.querySelectorAll('[data-gwp-add]')

    this.closeButtons.forEach((btn) =>
      btn.addEventListener('click', this.handleClose)
    )
    this.addButtons.forEach((btn) =>
      btn.addEventListener('click', this.handleAddClick)
    )

    this.removeInvalidGWPItem()
    this.updateCheckoutButton()
  }

  disconnectedCallback() {
    this.closeButtons.forEach((btn) =>
      btn.removeEventListener('click', this.handleClose)
    )
    this.addButtons.forEach((btn) =>
      btn.removeEventListener('click', this.handleAddClick)
    )
  }

  updateCheckoutButton() {
    const checkoutButton = document.querySelector('button[name="checkout"]')
    if (checkoutButton && this.isGwpEligible && !this.gwpLineKey) {
      checkoutButton.disabled = true
      checkoutButton.innerText = this.getAttribute('data-disabled-checkout-button-text')
    }
  }

  setLoading(isLoading) {
    if (isLoading) {
      this.setAttribute('loading', '')
    } else {
      this.removeAttribute('loading')
    }
  }

  removeInvalidGWPItem() {
    if (this.gwpLineKey && this.hasAttribute('data-gwp-invalid')) {
      this.setLoading(true)
      this.removeGWPItemFromCart(this.gwpLineKey, true)
      this.setLoading(false)
    }
  }

  handleClose(e) {
    e.preventDefault()

    this.drawer.close()
  }

  async handleAddClick(e) {
    e.preventDefault()

    const button = e.currentTarget
    const variantId = button.getAttribute('data-variant-id')

    this.setLoading(true)

    if (this.gwpLineKey) {
      await this.removeGWPItemFromCart(this.gwpLineKey)
    }
    await this.addGWPItemToCart(variantId, true)

    this.setLoading(false)
    this.drawer.close()
  }

  async addGWPItemToCart(variantId, rerender = false) {
    try {
      const payload = {
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: {
              '_gwp-gift': 'true',
            },
          },
        ],
      }

      const cartResponse = await addToCart(payload)

      if (rerender) {
        reRenderShopifySections(cartResponse)
      }
    } catch (e) {
      console.error(e)
    }
  }

  async removeGWPItemFromCart(lineKey, rerender = false) {
    try {
      const payload = {
        updates: {
          [lineKey]: 0,
        },
      }

      const cartResponse = await updateCart(payload)

      if (rerender) {
        reRenderShopifySections(cartResponse)
      }
    } catch (e) {
      console.error(e)
    }
  }
}

customElements.define('gift-with-purchase', GiftWithPurchase)
